import { Controller } from "@hotwired/stimulus"

const DEFAULT_FRAME_ID = "admin_checkouts_results"

export default class extends Controller {
  static targets = ["skeleton"]
  static values = { frameId: { type: String, default: DEFAULT_FRAME_ID } }

  connect() {
    this._onBeforeFetch = this._onBeforeFetchRequest.bind(this)
    this._onFetchError = this._onFetchRequestError.bind(this)
    this._onFrameLoad = this._onTurboFrameLoad.bind(this)
    this._onFrameMissing = this._onTurboFrameMissing.bind(this)

    document.documentElement.addEventListener("turbo:before-fetch-request", this._onBeforeFetch)
    document.documentElement.addEventListener("turbo:fetch-request-error", this._onFetchError)

    this.element.addEventListener("turbo:frame-load", this._onFrameLoad, true)
    this.element.addEventListener("turbo:frame-missing", this._onFrameMissing, true)
  }

  disconnect() {
    document.documentElement.removeEventListener("turbo:before-fetch-request", this._onBeforeFetch)
    document.documentElement.removeEventListener("turbo:fetch-request-error", this._onFetchError)

    this.element.removeEventListener("turbo:frame-load", this._onFrameLoad, true)
    this.element.removeEventListener("turbo:frame-missing", this._onFrameMissing, true)
  }

  _turboFrameHeaderFromEvent(event) {
    const headers = event.detail?.fetchOptions?.headers
    if (!headers) return null
    if (typeof headers.get === "function") return headers.get("Turbo-Frame")
    return headers["Turbo-Frame"]
  }

  _onBeforeFetchRequest(event) {
    if (this._turboFrameHeaderFromEvent(event) !== this.frameIdValue) return
    if (this.hasSkeletonTarget) this.skeletonTarget.classList.remove("hidden")
  }

  _setSkeletonHidden(hidden) {
    if (this.hasSkeletonTarget) this.skeletonTarget.classList.toggle("hidden", hidden)
  }

  _onTurboFrameLoad(event) {
    if (event.target?.id !== this.frameIdValue) return
    this._setSkeletonHidden(true)
  }

  _onTurboFrameMissing(event) {
    if (event.target?.id !== this.frameIdValue) return
    this._setSkeletonHidden(true)
  }

  _onFetchRequestError() {
    this._setSkeletonHidden(true)
  }
}
